import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {FileManagerTag} from "../../../../shared/interface/file-manager-tag";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../../shared/services/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FilterService} from "../../../../shared/services/filter.service";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../../shared/ngrx/reducers";
import {delay, distinctUntilChanged, takeUntil, tap} from "rxjs/operators";
import {CountedAndPaginated} from "../../../../shared/interface/response/counted-and-paginated";
import {getCurrentRouteState} from "../../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../../shared/ngrx/route-serializer";
import {NgForm} from "@angular/forms";
import {FileManagerTagService} from "../../../../shared/services/file-manager-tag.service";
import {TagAddComponent} from "../tag-add/tag-add.component";

@Component({
  selector: 'app-all-tag-list',
  templateUrl: './all-tag-list.component.html',
  styleUrls: ['./all-tag-list.component.scss']
})
export class AllTagListComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filtersForm') filtersForm: NgForm;

  initialFilters: any;
  totalData = 0;
  tags: FileManagerTag[] = [];
  modify = false;
  userPermissions: ReplaySubject<UserPermissions>;
  displayedColumns: string[] = ['name', 'active', 'createAt', 'createdBy',  'action'];

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private activatedRoute: ActivatedRoute,
    private filterService: FilterService,
    private store: Store<StoreRootState>,
    private router: Router,
    private fileManagerTagService: FileManagerTagService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.fileManagerTagService.getTagListSubject()
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<FileManagerTag>) => {
          this.tags = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
    }, filters);
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: event.pageIndex,
        pageSize: event.pageSize,
        ...this.filtersForm.value
      })]);
    });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;
        this.loadListData();
      })
    ;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  buildFilters(): any {
    return {...this.initialFilters};
  }

  loadListData(): void {
    this.fileManagerTagService.loadList(this.paginator.pageIndex, this.paginator.pageSize, this.buildFilters() );
  }

  filter(): void {
    this.loadListData();
  }

  add(): void {
    const dialogRef = this.dialog.open(TagAddComponent, {
      width: '700px',
      data: {
        tag: null,
        mod: false,
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadListData();
    });
  }

  mod(tag: FileManagerTag): void {
    const dialogRef = this.dialog.open(TagAddComponent, {
      width: '700px',
      data: {
        tag,
        mod: true,
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadListData();
    });
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
  }

}
